document.addEventListener("DOMContentLoaded", () => {
  if (!("open" in document.createElement("details"))) {
    document.documentElement.classList.add("no-details")
  }
})
